import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import i18n from "./i18n";

loadFonts();

//createApp(App).use(router).use(store).use(vuetify).mount("#app");

const app = createApp(App);
app.use(router);
app.use(store);
app.use(i18n);
app.use(vuetify);
app.mount("#app");
